/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".hdrRepeat[_ngcontent-%COMP%]{background-size:100% auto;background-repeat:repeat}.hdrNoRepeat[_ngcontent-%COMP%], .hdrRepeat[_ngcontent-%COMP%]{color:#000;font-family:Numans,sans-serif}.dtlNoRepeat[_ngcontent-%COMP%], .hdrNoRepeat[_ngcontent-%COMP%]{background-size:contain;background-repeat:no-repeat}.dtlNoRepeat[_ngcontent-%COMP%]{background-color:#5e3e19;height:100%}.dtlRepeat[_ngcontent-%COMP%]{background-color:#3f2c16;background-size:contain;height:100%}"];
export { styles as styles };

